import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { H2, Markdown, Prose } from '@criteria-labs/react-typography';
import { ContentView } from '../content-view';
import { Section } from '../section';
export function EndpointRequestBodySection({ endpoint }) {
    const requestBody = endpoint.operation.requestBody;
    if (!requestBody) {
        return null;
    }
    return (_jsxs(Section, { children: [_jsxs(Prose, { className: "max-w-none", children: [_jsx(H2, { children: "Request body" }), _jsx(Markdown, { children: requestBody.description })] }), _jsx(ContentView, { content: requestBody.content })] }));
}
